import React, { forwardRef } from 'react';
import { StyleSheet, Text, TextInput, View } from 'react-native';

// A controlled value update does not always emit onContentSizeChange on native.
// Let an invisible text copy size the field, including wrapping and Dynamic Type,
// while the same mounted input keeps focus, selection, and native scrolling.
const NativeComposerTextarea = forwardRef(function NativeComposerTextarea({
  value = '', style, maxFontSizeMultiplier, ...props
}, ref) {
  const { height, minHeight, maxHeight, ...textStyle } = StyleSheet.flatten(style) || {};
  return (
    <View style={{ minHeight, maxHeight, overflow: 'hidden' }}>
      <Text
        accessible={false}
        accessibilityElementsHidden
        importantForAccessibility="no-hide-descendants"
        pointerEvents="none"
        maxFontSizeMultiplier={maxFontSizeMultiplier}
        style={[textStyle, { opacity: 0, flexShrink: 0 }]}
      >
        {value ? `${value}\u200b` : ''}
      </Text>
      <TextInput
        {...props}
        ref={ref}
        value={value}
        maxFontSizeMultiplier={maxFontSizeMultiplier}
        style={[textStyle, StyleSheet.absoluteFillObject]}
      />
    </View>
  );
});

export default NativeComposerTextarea;
